// Mails (lot 4.3) : ce qu'Alfred a relevé, classé en tâche de fond (à regarder, info, publicité), avec le résumé d'une
// ligne quand il existe. On touche une ligne pour lire l'extrait. Rien ne se répond ni ne se supprime d'ici : la boîte
// est en lecture seule.

import { useCallback, useEffect, useState } from 'react';

import type { Actions } from '../App';
import { EnTeteRetour, Fenetre } from '../components';
import { type MailReleve, NonConnecte, api } from '../lib/api';

type Filtre = 'importants' | 'info' | 'publicite' | 'tous';

const FILTRES: [Filtre, string][] = [['importants', 'À regarder'], ['tous', 'Tous'], ['info', 'Info'], ['publicite', 'Publicité']];

const quand = (iso: string) => new Date(iso).toLocaleString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
const nom = (de: string) => de.replace(/<[^>]*>/, '').replace(/"/g, '').trim() || de;

export function Mails({ actions }: { actions: Actions }) {
  const [filtre, setFiltre] = useState<Filtre>('importants');
  const [mails, setMails] = useState<MailReleve[] | null>(null);
  const [ouvert, setOuvert] = useState<number | null>(null);

  const charger = useCallback(() => {
    setMails(null);
    api.mails(100, filtre === 'tous' ? undefined : filtre).then(setMails).catch((e: unknown) => {
      if (e instanceof NonConnecte) window.location.hash = '#/connexion';
      else actions.toast({ texte: (e as Error).message, erreur: true });
    });
  }, [filtre, actions]);

  useEffect(charger, [charger]);

  return (
    <main className="ecran">
      <EnTeteRetour titre="Mails" retour="#/connexions" />
      <div className="filtres-mails" role="tablist">
        {FILTRES.map(([f, libelle]) => (
          <button key={f} role="tab" aria-selected={filtre === f} className={`btn petit${filtre === f ? ' principal' : ''}`} onClick={() => setFiltre(f)}>{libelle}</button>
        ))}
      </div>
      <Fenetre>
        {mails === null && <p className="muted" style={{ margin: 0 }}>Chargement…</p>}
        {mails?.length === 0 && (
          <p className="muted" style={{ margin: 0 }}>
            {filtre === 'importants' ? 'Rien à regarder pour l’instant.' : 'Aucun mail ici.'} Les mails des 30 derniers jours apparaissent ici ; le classement se fait quelques minutes après leur arrivée.
          </p>
        )}
        {mails?.map((m) => (
          <button key={m.id} className="mail" aria-expanded={ouvert === m.id} onClick={() => setOuvert(ouvert === m.id ? null : m.id)}>
            <span className="sujet">{m.sujet || '(sans objet)'}</span>
            <small className="muted">{nom(m.de)} · {quand(m.recuLe)}{m.indesirable ? ' · indésirables' : ''}{m.categorie === null ? ' · pas encore classé' : ''}</small>
            {m.resume && <small>{m.resume}</small>}
            {ouvert === m.id && <span className="extrait">{m.extrait || '(pas de texte)'}</span>}
          </button>
        ))}
      </Fenetre>
    </main>
  );
}
